import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api';
import { PageHeader, Table } from './AdminUI';

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  useEffect(() => { adminApi.newsletter().then(setItems); }, []);

  const exportCsv = () => {
    const csv = 'email,lang,created_at\n' + items.map(i => `${i.email},${i.lang},${i.created_at}`).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `yup-newsletter-${new Date().toISOString().slice(0,10)}.csv`;
    a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div>
      <PageHeader title="Newsletter" subtitle={`${items.length} iscritti`} action={<button onClick={exportCsv} className="btn-primary">Esporta CSV</button>} />
      <Table
        columns={[
          { key: 'email', label: 'Email' },
          { key: 'lang', label: 'Lingua' },
          { key: 'created_at', label: 'Iscritto il', render: r => r.created_at ? new Date(r.created_at).toLocaleString('it-IT') : '—' }
        ]}
        rows={items}
      />
    </div>
  );
}
